<ul>
  @switch (role?.name) {
    <!--Lowest role starts here to highest role -->
    @case (roleType.DEVELOPER) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForAllRoles"></ng-container></li>
    }
    @case (roleType.ADMIN) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForAllRoles"></ng-container></li>
    }
    @case (roleType.ADMINISTRATOR) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForAllRoles"></ng-container></li>
    }
    @case (roleType.ARCHITECT) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForAllRoles"></ng-container></li>
    }
    @case (roleType.SYSTEM_ADMINISTRATOR) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForAllRoles"></ng-container></li>
    }
    @case (roleType.GENESYS_CLOUD_VOICE_ADMIN) {
      <li><ng-container *ngTemplateOutlet="genesysCloudCommunity"></ng-container></li>
    }
    @case (roleType.COMMUNICATE_ADMIN) {
      <li><ng-container *ngTemplateOutlet="genesysCloudCommunity"></ng-container></li>
    }
    @case (roleType.TELEPHONY_ADMIN) {
      <li><ng-container *ngTemplateOutlet="genesysCloudCommunity"></ng-container></li>
    }
    @case (roleType.OUTBOUND_ADMIN) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForAllRoles"></ng-container></li>
    }
    @case (roleType.WEM_QUALITY_ADMIN) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForWEM"></ng-container></li>
    }
    @case (roleType.WEM_QUALITY_ADMINISTRATOR) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForWEM"></ng-container></li>
    }
    @case (roleType.WEM_PERFORMANCE_MANAGEMENT_ADMIN) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForWEM"></ng-container></li>
    }
    @case (roleType.WEM_PLANNER_ADMIN) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForWEM"></ng-container></li>
    }
    @case (roleType.WEM_PLANNING_ADMIN) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForWEM"></ng-container></li>
    }
    @case (roleType.SUPERVISOR) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForWEM"></ng-container></li>
    }
    @case (roleType.MASTER_ADMIN) {
      <li><ng-container *ngTemplateOutlet="sharedLinksForWEM"></ng-container></li>
    }
    @default {
      <!--Show for no roles assigned including Agents, unassigned Roles-->
      <li><ng-container *ngTemplateOutlet="genesysCloudCommunity"></ng-container></li>
    }
  }
</ul>

<ng-template #genesysCloudCommunity>
  <a
    class="overlay-link"
    (click)="onLinkClick()"
    href="https://orchestrators.genesys.com/community"
    target="_blank"
    title="Genesys Community Link"
    >Genesys Community</a
  >
</ng-template>

<ng-template #WEMCommunity>
  <li>
    <a
      class="overlay-link"
      (click)="onLinkClick()"
      href="https://community.genesys.com/communities/workforce-optimization?CommunityKey=f6e20f73-2c94-4b44-be95-118216aafb4f"
      target="_blank"
      title="WEM Community Link"
      >WEM Community</a
    >
  </li>
</ng-template>

<ng-template #developerForumCommunity>
  <a
    class="overlay-link"
    (click)="onLinkClick()"
    href="https://developer.genesys.cloud/forum/"
    target="_blank"
    title="Developer Forum Link"
    >Developer Forum</a
  >
</ng-template>

<ng-template #developerCenter>
  <a
    class="overlay-link"
    (click)="onLinkClick()"
    href="https://developer.genesys.cloud"
    target="_blank"
    title="Developer Center Link"
    >Developer Center</a
  >
</ng-template>

<ng-template #sharedLinksForAllRoles>
  <li>
    <ng-container *ngTemplateOutlet="genesysCloudCommunity"></ng-container>
  </li>
  <li>
    <ng-container *ngTemplateOutlet="developerForumCommunity"></ng-container>
  </li>
  <li>
    <ng-container *ngTemplateOutlet="developerCenter"></ng-container>
  </li>
</ng-template>

<ng-template #sharedLinksForWEM>
  <ng-container *ngTemplateOutlet="WEMCommunity"></ng-container>
  <ng-container *ngTemplateOutlet="sharedLinksForAllRoles"></ng-container>
</ng-template>
